/**
 * PrototypeRoute — /prototypes/:prototypeId.
 *
 * Prototypes have no nav surface: this URL is reached from chat artifact
 * cards, the work item case file's Prototypes strip, and pasted links
 * (prototypeUrl in @yagni/shared appUrls).
 */
import { PrototypeShell } from "./PrototypeShell.js";

export function PrototypeRoute() {
  return <PrototypeShell />;
}
